import { render, staticRenderFns } from "./viewPenerima.vue?vue&type=template&id=62958193&"
import script from "./viewPenerima.vue?vue&type=script&lang=js&"
export * from "./viewPenerima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,Ripple} from 'quasar'
component.options.components = Object.assign({QList,QItem}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
